import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useActiveAccount } from "thirdweb/react";
import ThirdwebWalletConnect from "../components/ThirdwebWalletConnect";

interface LocationState {
  revealedLinks?: Record<string, string>;
  address?: string;
}

export const ChimpersReward = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const account = useActiveAccount();
  const address = account?.address;
  const state = location.state as LocationState;

  const revealedLinks = state?.revealedLinks || {};
  const tokenIds = Object.keys(revealedLinks);
  const [claimedRewards, setClaimedRewards] = useState<Set<string>>(new Set());

  if (!address) {
    return (
      <div className="flex justify-center items-center bg-gray-50 min-h-[calc(100dvh-149.5px)] p-6">
        <div className="mx-auto w-full text-center">
          <div className="p-8 bg-white rounded-lg shadow-md">
            <img
              src="/images/223-logo.png"
              alt="223 Logo"
              className="mx-auto mb-4 max-w-[100px]"
            />

            <h1 className="mb-4 text-2xl font-bold text-gray-900">
              Connect Your Wallet
            </h1>

            <div className="flex justify-center">
              <ThirdwebWalletConnect showDropdown={false} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!tokenIds || tokenIds.length === 0) {
    return (
      <div className="px-6 py-8">
        <div className="text-center">
          <h1 className="mb-4 text-2xl font-bold">No Rewards Available</h1>

          <p className="mb-6 text-[#666666]">
            Please claim your rewards first to see them here.
          </p>

          <button
            onClick={() => navigate("/rewards")}
            className="px-6 py-3 text-white bg-black rounded-lg transition-colors hover:bg-gray-800"
          >
            Go to Rewards Page
          </button>
        </div>
      </div>
    );
  }

  const handleClaimReward = (tokenId: string, secretLink: string) => {
    setClaimedRewards((prev) => {
      const newSet = new Set(prev);
      newSet.add(tokenId);
      return newSet;
    });

    // Open the secret link in a new tab
    window.open(secretLink, "_blank", "noopener,noreferrer");
    console.log(
      `Claiming reward for token ID: ${tokenId}, Link: ${secretLink}`
    );
  };

  const gradients = [
    { from: "#4CAF50", to: "#45A049", buttonColor: "#4CAF50" },
    { from: "#FF6B6B", to: "#FF8E53", buttonColor: "#FF6B6B" },
  ];

  return (
    <div className="px-6">
      <div className="mb-3">
        <h1 className="mb-1.5 text-2xl font-bold">Chimpers Rewards</h1>

        <p className="text-[#666666]">
          Claim and rip open your digital collectible packs to unlock Chimpi
          cards and a chance to win rewards!
        </p>
      </div>

      <div className="mb-4 space-y-3">
        {tokenIds.map((tokenId, index) => {
          const isClaimed = claimedRewards.has(tokenId);
          const secretLink = revealedLinks[tokenId];
          const gradient = gradients[isClaimed ? 0 : 1];

          return (
            <div
              key={tokenId}
              className={`flex justify-between items-center p-4 w-full bg-gradient-to-r rounded-lg`}
              style={{
                backgroundImage: `linear-gradient(to right, ${gradient.from}, ${gradient.to})`,
              }}
            >
              <div className="flex gap-3 items-center">
                <div className="flex items-center justify-center w-[48px] h-[48px] bg-[#FFFFFF33] rounded-[10px]">
                  <img
                    src={"/images/reward-open.png"}
                    alt="gift"
                    className="max-w-[32px]"
                  />
                </div>

                <h6 className="font-bold text-white">Card Pack #{index + 1}</h6>
              </div>

              <button
                onClick={() => handleClaimReward(tokenId, secretLink)}
                disabled={isClaimed}
                className="w-[78px] h-[31px] rounded-[50px] bg-white font-bold text-xs disabled:opacity-70"
                style={{
                  color: isClaimed ? "#666" : gradient.buttonColor,
                }}
              >
                {isClaimed ? "Claimed" : "Open"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
